module.exports = __webpack_public_path__ + "static/gm-22-244e5fe68db29999513fe64fce7b97ea.jpg";